import React from 'react';
import DocumentacaoContainer from '../components/Documentacao/DocumentacaoContainer';

const Documentacao: React.FC = () => {
  return <DocumentacaoContainer />;
};

export default Documentacao;
